import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthLayout } from '../../../shared/components/auth';
import MagicCodeLoginForm from '../components/MagicCodeLoginForm';
import { Routes as AppRoutes } from '../../../routes';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation() as unknown as { state?: { from?: string } };

  const handleSuccess = () => {
    const redirectTo = location?.state?.from || AppRoutes.sites.manage;
    navigate(redirectTo, { replace: true });
  };

  return (
    <AuthLayout variant="login">
      <MagicCodeLoginForm onLoginSuccess={handleSuccess} />
    </AuthLayout>
  );
};

export default LoginPage;
